import { Injectable } from '@angular/core';
import { AppConfig } from 'src/app/configs/app.config';
import { BehaviorSubject } from 'rxjs';
import { MenuList_Developer, MenuList_Admin, MenuList_Default } from 'src/app/configs/menu.config';
import { Action_Default, Action_Developer, Action_Admin } from 'src/app/configs/act.config';

interface Config {
    brand_text: string,
    favicon: string,
    logo_light: string,
    logo_dark: string,
    footer_text: string,
    footer_text2: string,
    footer_about_text: string,
    main_url: string,
    sso_url: string,
    admin_url: string
}

@Injectable({
    providedIn: 'root'
})
export class LoaderService {

    loaded = new BehaviorSubject(false);
    config: Config;
    menuList;
    actConfig;
    userGroup;

    constructor(
    ) { }

    init() {
        this.config = AppConfig
        this.change()
    }

    loadUserConfig(userGroup) {
        this.userGroup = userGroup
        if (userGroup == 0) {
            this.menuList = MenuList_Default
            this.actConfig = Action_Default
        }
        else if (userGroup == 1 || userGroup == 2) {
            this.menuList = MenuList_Developer
            this.actConfig = Action_Developer
        }
        else if (userGroup == 99) {
            this.menuList = MenuList_Admin
            this.actConfig = Action_Admin
        }
        this.loaded.next(true)
    }

    change() {
        document.title = this.config.brand_text
        let link: any = document.querySelector("link[rel*='icon']") || document.createElement('link');
        link.type = 'image/x-icon';
        link.rel = 'shortcut icon';
        link.href = this.config.favicon;
        document.getElementsByTagName('head')[0].appendChild(link);
    }


}